import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { InsightObjectTimelineSkeleton } from '@atlassian/jira-skeletons/src/ui/insight-object-timeline/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyObjectTimeline = lazy(
	() => import(/* webpackChunkName: "insight-object-timeline" */ './ui'),
);

export const AsyncInsightObjectTimeline = () => (
	<Placeholder name="insight-object-timeline" fallback={<InsightObjectTimelineSkeleton />}>
		<LazyObjectTimeline />
	</Placeholder>
);
